import type { ButtonHTMLAttributes, ReactNode } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
	children: ReactNode;
	/** Optional extra classes; prefer spacing via parent `.wi-cta-row`. */
	className?: string;
};

/**
 * Dominant screen action — inverse fill (`bg-wi-text` / `text-wi-surface`).
 * Convention: **one PrimaryButton per screen** (or per distinct view state).
 * Pair with {@link SecondaryLink} on the same row via `.wi-cta-row`; never stack equal-weight buttons.
 */
export function PrimaryButton({ children, className = "", type = "button", disabled, ...rest }: Props) {
	return (
		<button
			type={type}
			disabled={disabled}
			className={[
				"wi-primary-soft-hover inline-flex min-h-11 items-center justify-center rounded-wi-control bg-wi-text px-7 py-3.5",
				"font-sans text-body-sm font-medium text-wi-surface",
				"transition-[opacity,background-color,transform] duration-wi-fast ease-wi-out",
				"active:scale-[0.98]",
				"disabled:cursor-not-allowed disabled:opacity-50",
				"focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wi-gold",
				className,
			]
				.filter(Boolean)
				.join(" ")}
			{...rest}
		>
			{children}
		</button>
	);
}
